import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, NgControl, ReactiveFormsModule } from '@angular/forms';
import { FontStore } from '../../../../services/api/font/font-store.service';
import { FormInputComponent } from '../form-input.component';
import { ToFormControlPipe } from '../../../../pipes/to-form-control/to-form-control.pipe';
import { DropDownComponent } from '../drop-down/drop-down.component';
import { LoadingAnimationComponent } from '../../../feedback/loading-animation/loading-animation.component';

@Component({
  selector: 'aw-font-select',
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ToFormControlPipe,
    DropDownComponent,
    LoadingAnimationComponent,
  ],
  templateUrl: './font-select.component.html',
  styles: ``,
})
export class FontSelectComponent extends FormInputComponent {
  protected readonly fontStore: FontStore = inject(FontStore);

  constructor(public override ngControl: NgControl) {
    super(ngControl);
  }
}
